module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_agreable_m2.2ff19cb590a655032217ad0cdd1a7dd8.png";